import { render, staticRenderFns } from "./PackageSummary.vue?vue&type=template&id=24e43331"
import script from "./PackageSummary.vue?vue&type=script&lang=ts"
export * from "./PackageSummary.vue?vue&type=script&lang=ts"
import style0 from "./PackageSummary.vue?vue&type=style&index=0&id=24e43331&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports